module.exports = __webpack_public_path__ + "img/GoblinMale_Heavy.38dd172d.png";